import axios from 'axios';
import {useQuery} from '@tanstack/react-query';

import {Keys} from 'client/api/_keys';
import {Routes} from 'client/api/_routes';

const home = async () => axios.get(Routes.HOME);

export const useHome = () =>
  useQuery({
    queryKey: [Keys.HOME_QRY],
    queryFn: home,
    cacheTime: 0,
  });
